// Mapping "out" per la tab L3 (Idraulica).
// Contratto campi diagnosis.L3.* fissato in
// apps/web-bo/plans/features/l3-idraulica-tab.md — 1:1 con il form
// locale di useInspectionL3.js, nessuna scrittura incrociata su
// common/L0/L1/L2 (a differenza di mappingOutL0.js, che pulisce dei campi
// L1 dipendenti da un campo L0 — qui non serve, L3 è isolato per decisione
// di prodotto §0.2).
//
// Come mappingOutL0.js/mappingOutL1.js, il risultato va restituito come
// stringa JSON già pronta per essere assegnata a `body.diagnosis`: è il
// contratto imposto da `InspectionDiagnosisUpdatesDto.diagnosis: string`
// lato BE (apps/api/src/inspections/dto/request/inspection-diagnosis-updates.dto.ts),
// che fa un secondo `JSON.parse` su quel campo.
//
// Nota: `cdaSormonto`/`cdaErosione`/`cdaIdraulica` (calcolati da
// calculateSormontoCdaL3/calculateErosioneCdaL3, apps/api/.../diagnosis.ts)
// e `cdaGraphicalRepresentation` (InspectionExtensions.
// calculateHydraulicCdaGraphicalRepresentationL3, stesso file) non sono
// inclusi qui — sono di sola proprietà BE, ricalcolati ad ogni salvataggio
// dentro InspectionsService.updateDiagnosis/calculateHydraulicCdaL3
// indipendentemente da cosa arriva nel payload, quindi non serve (né
// avrebbe senso) inviarli.
export function mappingDataOutL3(data) {
  const parseNumberOrNull = value => {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const diagnosisData = {
    L3: {
      // 1. Informazioni generali
      analisiFenomenoAnalizzato: data.analisiFenomenoAnalizzato || null, // 577
      rilevatore: data.rilevatore || null, // 578
      dataAttivita: data.dataAttivita || null, // 579
      ispezioniSpecialiFenomeni: data.ispezioniSpecialiFenomeni || null, // 97b
      indicatoriIspezioniSpecialiSormonto:
        data.indicatoriIspezioniSpecialiSormonto || null, // 97c
      indicatoriIspezioniSpecialiErosione:
        data.indicatoriIspezioniSpecialiErosione || null, // 97f

      // 2. Dati idraulici
      portataQP3: parseNumberOrNull(data.portataQP3), // 580
      portataQP2: parseNumberOrNull(data.portataQP2), // 581
      portataQP1: parseNumberOrNull(data.portataQP1), // 582
      velocitaAMonteVP3: parseNumberOrNull(data.velocitaAMonteVP3), // 583
      velocitaAMonteVP2: parseNumberOrNull(data.velocitaAMonteVP2), // 584
      velocitaAMonteVP1: parseNumberOrNull(data.velocitaAMonteVP1), // 585
      quotaPeloLiberoP3: parseNumberOrNull(data.quotaPeloLiberoP3), // 139
      quotaPeloLiberoP2: parseNumberOrNull(data.quotaPeloLiberoP2), // 138
      quotaPeloLiberoP1: parseNumberOrNull(data.quotaPeloLiberoP1), // 587
      quotaMinimaFondoAlveo: parseNumberOrNull(data.quotaMinimaFondoAlveo), // 593
      pendenzaMedia: parseNumberOrNull(data.pendenzaMedia), // 608

      // 3. Sormonto
      quotaMinimaIntradosso: parseNumberOrNull(data.quotaMinimaIntradosso), // 134
      spessoreImpalcato: parseNumberOrNull(data.spessoreImpalcato), // 588
      francoIdraulicoFP2: parseNumberOrNull(data.francoIdraulicoFP2), // 141

      // 4. Erosione
      evidenzeProfonditaDelleFondazioni:
        data.evidenzeProfonditaDelleFondazioni || null, // 164
      massimaProfonditaScavoLocalizzata: parseNumberOrNull(
        data.massimaProfonditaScavoLocalizzata
      ), // 158
      massimaProfonditaScavoContrazione: parseNumberOrNull(
        data.massimaProfonditaScavoContrazione
      ), // 589
      massimaProfonditaScavoAltriFenomeni: parseNumberOrNull(
        data.massimaProfonditaScavoAltriFenomeni
      ), // 590
      massimaProfonditaScavoTotale: parseNumberOrNull(
        data.massimaProfonditaScavoTotale
      ), // 591
      profonditaFondazioneRispettoAlveo: parseNumberOrNull(
        data.profonditaFondazioneRispettoAlveo
      ), // 159
      // 159b — checkbox Effettiva/Presunta (Accordion4ErosionL3.jsx, stessa
      // UX di Accordion4HydraulicRiskL1.jsx) non incluse qui di proposito:
      // sono solo input UI che derivano questo flag via useEffect, che è
      // l'unico valore persistito; mappingInL3.js le ricostruisce da qui al
      // caricamento (vedi deriveProfonditaFondazioneRispettoAlveoCheckboxes).
      profonditaFondazioneRispettoAlveoFlag:
        data.profonditaFondazioneRispettoAlveoFlag || null, // 159b
      rapportoDsTotDf: parseNumberOrNull(data.rapportoDsTotDf), // 592
      protezioneAlPiedePileSpalle: data.protezioneAlPiedePileSpalle || null, // 171
      estensioneProtezioneAlPiede: data.estensioneProtezioneAlPiede || null, // 612
      statoConservazioneProtezionePiede:
        data.statoConservazioneProtezionePiede || null, // 172

      // 5. CdA Idraulica (609/610 manuali per design, no calcolo — vedi
      // apps/api/.../diagnosis.ts; cdaSormonto/cdaErosione/cdaIdraulica sono
      // calcolati dal BE, vedi nota in testa al file)
      esitoDellaValutazione: data.esitoDellaValutazione || null, // 609
      condizioniTransitabilita: data.condizioniTransitabilita || null, // 610

      // 6. Commenti per report
      inquadramentoTerritorialeDescrizione:
        data.inquadramentoTerritorialeDescrizione || null, // 594
      inquadramentoTerritorialeImmagini:
        data.inquadramentoTerritorialeImmagini || null, // 595
      documentazioneDisponibileDescrizione:
        data.documentazioneDisponibileDescrizione || null, // 596
      documentazioneDisponibileImmagini:
        data.documentazioneDisponibileImmagini || null, // 597
      descrizioneStrutturaDescrizione:
        data.descrizioneStrutturaDescrizione || null, // 598
      descrizioneStrutturaImmagini: data.descrizioneStrutturaImmagini || null, // 599
      caratterizzazioneSistemaDescrizione:
        data.caratterizzazioneSistemaDescrizione || null, // 600
      caratterizzazioneSistemaImmagini:
        data.caratterizzazioneSistemaImmagini || null, // 601
      scenariIdrauliciRiferimentoDescrizione:
        data.scenariIdrauliciRiferimentoDescrizione || null, // 602
      scenariIdrauliciRiferimentoImmagini:
        data.scenariIdrauliciRiferimentoImmagini || null, // 603
      valutazioneRischioSormontoFrancoIdraulico:
        data.valutazioneRischioSormontoFrancoIdraulico || null, // 604
      valutazioneRischioSormontoImmagini:
        data.valutazioneRischioSormontoImmagini || null, // 605
      valutazioneFenomeniErosiviTesto:
        data.valutazioneFenomeniErosiviTesto || null, // 606
      valutazioneFenomeniErosiviImmagini:
        data.valutazioneFenomeniErosiviImmagini || null, // 607
      conclusioniDescrizione: data.conclusioniDescrizione || null, // 611
    },
  };

  return JSON.stringify(diagnosisData);
}
